import { useEffect, useState } from "react";

/**
 * Returns `value` but only after it has been stable for `delayMs`.
 * Cancels the pending update when `value` changes again.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
